import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'

import styles from './Avatar.module.scss'

type AvatarProps = {
  theme?: string
  user?: {
    email?: string
  }
}

export const Avatar = ({ theme = 'regular', user = {} }: AvatarProps) => {
  const { email = '???' } = user

  return (
    <Box
      align="center"
      className={cx(styles.avatar, { [styles[theme]]: Boolean(theme) })}
      justify="center"
      tagName="span"
    >
      {email.slice(0, 2)}
    </Box>
  )
}
